var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view')],1),_c('snackbar'),_c('light-box'),(_vm.$store.getters.productDrawer)?_c('div',{staticStyle:{"position":"fixed","z-index":"99","top":"0","opacity":"50%","background":"black","height":"100vh","width":"100vw"},on:{"click":function($event){return _vm.$store.commit('setProductDrawer', false)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }